<mat-card appearance="outlined">
    <div class="mt-2">
        <p style="font-weight: bold" class="text-center">Importación de cuentas contables mediante Excel</p>
        <hr>
        <ng-container *ngIf="!dataReady">
            <p>Mediante el siguiente proceso podrá importar sus cuentas contables a Handly mediante una plantilla en
                Excel.
                Dicha
                plantilla deberá tener el formato indicado en el siguiente ejemplo:
            </p>
            <button mat-stroked-button (click)="downloadTemplate()">Descargar plantilla</button>
            <button mat-stroked-button (click)="downloadDemoTemplate()">Descargar ejemplo con datos</button>
            <p></p>
            <p>Una vez haya cumplimentado la plantilla correctamente, súbala en el siguiente paso y verá una vista
                previa de
                los datos.</p>
            <p></p>
            <input matinput type="file" (change)="fileChange($event)" placeholder="Upload file" accept=".xlsx">
        </ng-container>
        <ng-container *ngIf="working">
            <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
        </ng-container>
        <ng-container *ngIf="dataReady">
            <div style="text-align: center">
                <button style="margin: 0 auto" mat-stroked-button (click)="addAccounts()">Añadir cuentas contables a
                  Handly</button>
                <button mat-stroked-button (click)="closeDialog()">Cerrar</button>
            </div>
        </ng-container>
    </div>
</mat-card>
<ng-container *ngIf="dataReady">
    <ng-container *ngIf="!working">
        <app-table [columns]="headerTable" [dataSource]="dataSource"></app-table>
    </ng-container>
</ng-container>
